const getDateRanges = filter => {
  if (filter.type === 'DateRangeFilter') {
    return [
      [
        filter.config.gte || filter.config.gt,
        filter.config.lte || filter.config.lt,
      ],
    ];
  }

  if (Array.isArray(filter.config)) {
    return filter.config.map(getDateRanges).reduce((a, b) => a.concat(b), []);
  }

  return [];
};

export default getDateRanges;
